function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "List/B",
  transform: "translate(-16.000000, -10.000000)",
  fillRule: "nonzero"
}, /*#__PURE__*/React.createElement("g", {
  id: "icon_ract_Q",
  transform: "translate(16.000000, 10.000000)"
}, /*#__PURE__*/React.createElement("rect", {
  id: "Rectangle",
  fill: "#14C8C8",
  x: 0,
  y: 0,
  width: 40,
  height: 40
}), /*#__PURE__*/React.createElement("path", {
  d: "M28.3790996,11.2376386 C30.3800234,13.489769 31.4089787,16.3762724 31.2595101,19.3179845 C31.3903141,22.1763745 30.4236278,24.9827533 28.5387689,27.216545 C29.3721416,28.2493326 30.2374481,29.3426401 31.0679069,30.4965804 L28.6346299,32.5015228 C27.7693233,31.3170687 26.9359506,30.1936422 26.1026374,29.160911 C24.2718671,30.1196743 22.2060302,30.6014422 20.1152464,30.5572132 C16.9922978,30.7063828 13.9621038,29.5258491 11.8513933,27.3376977 C8.04953557,22.5879651 8.04953557,16.0176594 11.8513933,11.2679268 C13.9394149,9.04586375 16.9819555,7.84837188 20.1152464,8.01541576 C23.2390704,7.86461544 26.27034,9.04656116 28.3790996,11.2376386 Z M14.6040684,13.4243665 C12.1262608,16.9910225 12.1262608,21.6146583 14.6040684,25.1813144 C15.9700112,26.7059901 18.0088844,27.5373856 20.1152464,27.4286187 C21.4651781,27.4586993 22.8001168,27.1549779 23.9887585,26.5473284 C22.8359877,25.2116026 21.7468467,24.0273741 20.6901749,22.9642983 L22.8679215,20.9593559 C23.9887585,22.0830081 25.1095359,23.2672366 26.2013529,24.4818097 C27.1062958,22.8997238 27.5484211,21.1167902 27.4818591,19.3179845 C27.6075825,17.1656468 26.9392253,15.0389523 25.5915767,13.3031573 C24.1376023,11.9010491 22.1439619,11.1215075 20.0706065,11.1443798 C17.9972511,11.1672521 16.0232664,11.9905627 14.6040684,13.4243665 L14.6040684,13.4243665 Z",
  id: "Shape",
  fill: "#FFFFFF"
}))));

function SvgIconRactQ(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "40px",
    height: "40px",
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon_ract_Q") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRactQ);
export default __webpack_public_path__ + "static/media/icon_ract_Q.a5a53632.svg";
export { ForwardRef as ReactComponent };